<template>
  <div>
    <label class="formulate-input-label" style="margin:0;" for="valueGroup">{{label}}</label>
    <div id="valueGroup" style="display: flex; justify-content: space-between; gap: .5rem;">
      <NxInput
        name="dateInicial"
        type="date"
        placeholder="De:"
        v-model="startDate"
        :value="localInitialValue"
        @update:value="handleInitialValueUpdate"
        :max="getCurrentDate()"
      ></NxInput>
      <NxInput
        name="dateFinal"
        type="date"
        placeholder="Até:"
        v-model="endDate"
        :value="localFinalValue"
        @update:value="handleFinalValueUpdate"
        :max="getCurrentDate()"
        :min="getMinEndDate()"
      ></NxInput>
    </div>
  </div>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputDateRange',
  mixins: [useReactiveModelMixin('InitialValue'), useReactiveModelMixin('FinalValue')],
  props: {
    label: {
      required: true,
      type: String,
      default: null
    },
    limitToFifteenDays: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleInitialValueUpdate (val) {
      this.localInitialValue = val
      if (this.limitToFifteenDays) {
        this.enforceMaxRange(val)
      }
    },

    handleFinalValueUpdate (val) {
      this.localFinalValue = val
      if (val) {
        this.addOneDayToEndDate(val)
      }
    },

    addOneDayToEndDate (dateString) {
      if (!dateString) return

      // Converte a string pra Date
      const date = new Date(dateString)
      // Adiciona 1 dia
      date.setDate(date.getDate() + 1)
      // Atualiza localFinalValue com a data ajustada (no formato yyyy-MM-dd)
      this.localFinalValue = date.toISOString().split('T')[0]
    },

    getCurrentDate () {
      const today = new Date()
      return today.toISOString().split('T')[0]
    },

    getMinEndDate () {
      if (this.limitToFifteenDays && this.localInitialValue) {
        const minDate = new Date(this.localInitialValue)
        minDate.setDate(minDate.getDate() - 14)
        return minDate.toISOString().split('T')[0]
      }
      return null
    },

    enforceMaxRange (startDate) {
      if (!startDate) return
      const maxDate = new Date(startDate)
      maxDate.setDate(maxDate.getDate() + 14)
      this.localFinalValue = maxDate.toISOString().split('T')[0]
    }
  }
}
</script>

<style lang="scss" scoped>
#valueGroup {
  .formulate-input {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputDateRangeAtendimento.vue